@use "variables" as *;

.loadingIndicator {
  width: 20px !important;
  height: 20px !important;
  padding: $spacing-s;
}

.avatar {
  height: 100%;
  width: 100%;
}
